import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import Icon from '@material-ui/core/Icon'

import Wrapper from '../../components/Wrapper'
import Header from '../../components/Header'
import Body from '../../components/Body'
import Footer from '../../components/Footer'
import TopBar from '../../components/TopBar'
import SubmitButton from '../../components/SubmitButton'
import TrueMoney from '../../assets/motor/logo-truemoney_3.png'
import moment from 'moment'

import _ from 'lodash'
import numeral from 'numeral'

import Typography from '@material-ui/core/Typography'
import BackgroundImage from '../../assets/motor/background.png'
import BKIimage from '../../assets/images/newsuccess.png'
import BKIimageText from '../../assets/motor/Bkkins.svg-1-1024x216.png'
import iconFailed from '../../assets/motor/ic-failed@3x.png'
import SuccessFailed from '../../assets/motor/success_failed.png'
import { motorService } from '../../services/motor.service'
import Loading from '../../components/Loading'
import Modal from '@material-ui/core/Modal'

const fontDefault = {
  fontFamily: 'thonburiregular',
  fontStyle: 'normal',
}

const styles = {
  topBarImg: {
    height: '28px',
  },
  title: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '18px',
    textAlign: 'center',
    marginBottom: '3px',
    fontWeight: 'bold',
  },
  price: {
    ...fontDefault,
    fontSize: '36px',
    color: '#233987',
    textAlign: 'center',
    marginTop: '0px',
  },
  container: {
    marginTop: '10px',
    position: 'relative',
  },
  containerInside: {
    marginTop: '16px',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  text: {
    ...fontDefault,
    color: '#0e162c',
    fontSize: '14px',
  },
  textSan: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#0e162c',
    fontSize: '14px',
  },
  textFade: {
    ...fontDefault,
    color: '#878b96',
    fontSize: '14px',
    padding: '16px',
    display: 'block',
  },
  textSanFade: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#878b96',
    fontSize: '14px',
  },
  textBold: {
    ...fontDefault,
    color: '#0e162c',
    fontWeight: 'bold',
    fontSize: '16px',
  },
  textSanBold: {
    ...fontDefault,
    fontFamily: 'San Francisco Text',
    color: '#0e162c',
    fontSize: '16px',
    fontWeight: 'bold',
  },
  line: {
    borderTop: '1px solid #c3c5cb',
    borderBottom: 'none',
    marginTop: '16px',
    marginBottom: '16px',
    opacity: '0.5',
  },
  headDesc: {
    ...fontDefault,
    fontSize: '12px',
    color: '#878b96',
    textAlign: 'center',
    marginBottom: '0px',
    marginTop: '0px',
  },
  textTopBar: {
    ...fontDefault,
    color: '#333333',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backgroundImageContainer: {
    position: 'absolute',
    height: '160px',
    width: '100%',
  },
  backgroundImage: {
    height: '160px',
    objectFit: 'cover',
    width: '100%',
  },
  bkiLogo: {
    width: '90px',
    height: '90px',
    margin: '14px',
  },
  bkiLogoSuccess: {
    width: '130px',
    height: '176px',
    margin: '14px',
  },
  cardHeaderTitle: {
    color: '#0e162c',
    fontSize: '24px',
    fontWeight: 'bold',
    display: 'block',
    ...fontDefault,
  },
  cardHeaderDesc: {
    color: '#0e162c',
    fontSize: '16px',
    display: 'block',
    fontWeight: 'bold',
    textAlign: 'center',
    ...fontDefault,
  },
  card: {
    borderRadius: '8px',
    boxShadow: '0 2px 4px 0 rgba(94, 92, 92, 0.3)',
    backgroundImage: 'linear-gradient(162deg, #ffffff, #ffffff)',
    margin: '16px',
  },
  cardHeader: {
    backgroundColor: '#ddedfe',
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    padding: '16px',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  cardTitle: {
    color: '#118df5',
    fontSize: '18px',
    ...fontDefault,
  },
  cardContent: {
    padding: '16px',
  },
  fieldTitle: {
    ...fontDefault,
    fontSize: '16px',
    color: '#0e162c',
    display: 'block',
  },
  fieldValue: {
    color: '#999999',
    marginTop: '3px',
    display: 'block',
  },
  fieldContainer: {
    marginTop: '3px',
    marginBottom: '10px',
  },
}

class PaymentSuccessMotor extends Component {
  state = {
    isLoading: true,
    isv_payment_ref: '',
    transaction: {},
    policy_product: [],
    isSuccess: false,
  }

  goToNextPage = () => {
    const {
      history: { push },
    } = this.props
    push('/')
  }

  refetch = async (authData, motorData, isv_payment_ref) => {
    try {
      const token = _.get(authData, 'token', null)
      const response = await motorService.getOrder(token, isv_payment_ref)
      const transaction = _.get(response, 'transaction', {})
      const transaction_status = _.get(transaction, 'transaction_status', '')
      const tmn_transaction_status = _.get(
        transaction,
        'tmn_transaction_status',
        ''
      )
      const policy_product = _.get(response, 'policy_product', [])
      if (
        (transaction_status === '' && tmn_transaction_status === '') ||
        policy_product.length === 0 ||
        policy_product.filter(product => {
          return (
            product.status !== 'failed' &&
            !!_.get(product, 'policy_number', '').trim === false
          )
        }).length > 0
      ) {
        throw 'pending'
      } else if (tmn_transaction_status === 'null') {
        const { showError, history } = this.props
        showError('Payment Timeout')
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.track('Insurance Car Error', {
            'Error message': 'Payment Timeout',
            'Error code': 'E10800',
          })
        }
        const dataLayer = _.get(window, 'dataLayer', undefined)
        if (!!dataLayer) {
          dataLayer.push({
            event: 'error-page', // Required
            errorMsg: 'Payment Timeout',
          })
        }
        history.push('/error-payment-timeout')
        this.setState({
          isLoading: false,
        })
        window.scrollTo(0, 0)
        return
      } else if (
        policy_product.filter(product => {
          return product.status === 'failed'
        }).length > 0
      ) {
        this.setState({
          isLoading: false,
          isSuccess: false,
          transaction,
          policy_product,
        })
        return
      }

      const currentProduct = _.get(motorData, 'userInput.currentProduct', '')
      const selectPrice = _.get(motorData, 'userInput.selectPrice', '')
      const carBrand = _.get(motorData, 'userInput.carBrand', '')
      const carModel = _.get(motorData, 'userInput.carModel', {})
      const carYear = _.get(motorData, 'userInput.carYear', '')
      const insuranceClass = _.get(motorData, 'userInput.insuranceClass', '')
      const userInput = _.get(motorData, 'userInput', '')
      const mixpanel = _.get(window, 'mixpanel', undefined)
      const currentPackage = _.get(userInput, 'currentPackage', {})
      if (!!mixpanel) {
        const transactionData = transaction
        mixpanel.track('Insurance Car Success', {
          'Insurance type':
            currentProduct === 'V'
              ? 'Voluntary Motor Insurance'
              : 'Compulsory Motor Insurance',
          'Insurance class': insuranceClass,
          Amount: selectPrice,
          'Car make': carBrand,
          'Car model': _.get(carModel, 'label', ''),
          'Car registration year': carYear,
        })
        mixpanel.people.set({
          'Last bought car insurance date': new Date(
            _.get(transactionData, 'transaction_at', new Date().toString())
          ).toLocaleString('th-TH'),
        })
      }
      const dataLayer = _.get(window, 'dataLayer', undefined)
      if (!!dataLayer) {
        const transactionData = transaction
        const orderSuccessDataPolicy = policy_product
        dataLayer.push({
          event: 'purchase', // Required
          currencyCode: 'THB',
          ecommerce: {
            purchase: {
              actionField: {
                id: _.get(transactionData, 'resp_transaction_id', ''),
                revenue: selectPrice,
                tax: '0.00',
                shipping: '0.00',
                coupon: '',
              },
              products: orderSuccessDataPolicy.map(x => {
                return {
                  id: x.id,
                  name:
                    x.product_sub_type === 'vmi'
                      ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                        ? 'ประกันรถยนต์ชั้น 2+'
                        : parseInt(_.get(currentPackage, 'risk', 0)) === 5
                        ? 'ประกันรถยนต์ชั้น 1'
                        : 'ประกันรถยนต์ชั้น 3'
                      : 'พ.ร.บ.รถยนต์',
                  category:
                    x.product_sub_type === 'vmi'
                      ? 'Voluntary Motor Insurance'
                      : 'Compulsory Motor Insurance',
                  brand: 'Bangkok Insurance',
                  variant:
                    x.product_sub_type === 'vmi'
                      ? parseInt(_.get(currentPackage, 'risk', 0)) === 5
                        ? 'ประกันรถยนต์ชั้น 2+'
                        : parseInt(_.get(currentPackage, 'risk', 0)) === 5
                        ? 'ประกันรถยนต์ชั้น 1'
                        : 'ประกันรถยนต์ชั้น 3'
                      : 'พ.ร.บ.รถยนต์',
                  price: x.package_price, // required
                  quantity: 1, // required
                }
              }),
            },
          },
        })
      }
      this.setState({
        transaction,
        policy_product,
        isLoading: false,
        isSuccess: true,
      })
    } catch (error) {
      setTimeout(() => {
        this.refetch(authData, motorData, isv_payment_ref)
      }, 1000)
    }
  }

  componentDidMount = async () => {
    const { history, resignAuth, resignMotor } = this.props
    const { location } = history
    if (_.get(location, 'search.length', 0) === 0) return history.push('/')
    const splittedData = _.get(location, 'search', '')
      .slice(1, _.get(location, 'search.length', 0))
      .split('&')
    const params = {}
    splittedData.forEach(data => {
      const splitMore = data.split('=')
      const key = splitMore[0]
      const value = splitMore[1]
      params[key] = value
    })
    const auth64 = _.get(params, 'a', '')
    const motor64 = _.get(params, 'm', '')
    const isv_payment_ref = _.get(params, 'isv_payment_ref', '')
    this.setState({
      isv_payment_ref,
    })
    const authjson = decodeURIComponent(escape(atob(auth64)))
    const motorjson = decodeURIComponent(escape(atob(motor64)))
    let authData = {}
    let motorData = {}
    try {
      authData = JSON.parse(authjson)
      const distinct_id = _.get(authData, 'distinct_id', '')
      if (!!distinct_id) {
        const mixpanel = _.get(window, 'mixpanel', undefined)
        if (!!mixpanel) {
          mixpanel.identify(distinct_id)
        }
      }
    } catch {}
    try {
      motorData = JSON.parse(motorjson)
    } catch {}
    if (Object.keys(authData).length > 0) {
      resignAuth(authData)
    }
    if (Object.keys(motorData).length > 0) {
      resignMotor(motorData)
    }
    if (Object.keys(motorData).length > 0 || Object.keys(authData).length > 0) {
      history.push('/payment-success-motor?isv_payment_ref=' + isv_payment_ref)
    }
    this.refetch(authData, motorData, isv_payment_ref)
  }

  render() {
    const {
      isLoading,
      isv_payment_ref,
      transaction,
      policy_product,
      isSuccess,
    } = this.state
    const { classes, userInput, currentProduct, selectPrice } = this.props
    const { isVMIIncludeCMI, email = '' } = userInput
    const currentPackage = _.get(userInput, 'currentPackage', {})
    const transactionData = transaction
    const effDate = _.get(transactionData, 'coverage_from', '0001-01-01') //_.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    const effDateTo = _.get(transactionData, 'coverage_to', '0001-01-01') //_.get(userInput, 'effDate', '0001-01-01') || '0001-01-01'
    const startEffDate = moment(effDate).format('YYYY-MM-DD')
    const endEffDate = moment(effDateTo).format('YYYY-MM-DD')
    const dateFromTo = startEffDate + ' - ' + endEffDate

    const policyNumberArray = []
    const orderSuccessDataPolicy = policy_product

    const plate =
      _.get(orderSuccessDataPolicy[0], 'license_plate', '') +
      ' ' +
      _.get(orderSuccessDataPolicy[0], 'province_name', '')
    orderSuccessDataPolicy.forEach(policy => {
      policyNumberArray.push(_.get(policy, 'policy_number', ''))
    })
    const policyNumber = policyNumberArray.map(x => {
      return <span className={classes.fieldValue}>{x}</span>
    })
    const product_count = orderSuccessDataPolicy.length
    const has_one =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === '1' || product.plan_type === 1
      }).length > 0
    const has_two =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === '5' || product.plan_type === 5
      }).length > 0
    const has_three =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === '3' || product.plan_type === 3
      }).length > 0
    const has_cmi =
      orderSuccessDataPolicy.filter(product => {
        return product.product_sub_type === 'cmi'
      }).length > 0
    const has_sedan =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === 'sedan'
      }).length > 0
    const has_van =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === 'van'
      }).length > 0
    const has_pickup =
      orderSuccessDataPolicy.filter(product => {
        return product.plan_type === 'pickup'
      }).length > 0
    let product_name = ''
    if (product_count === 1 && has_one) {
      product_name = 'ประกันรถยนต์ชั้น 1'
    } else if (product_count === 1 && has_two) {
      product_name = 'ประกันรถยนต์ชั้น 2+'
    } else if (product_count === 1 && has_three) {
      product_name = 'ประกันรถยนต์ชั้น 3'
    } else if (product_count > 1 && has_one && has_sedan) {
      product_name = 'ประกันรถยนต์ชั้น 1 + พ.ร.บ.รถยนต์'
    } else if (product_count > 1 && has_two && has_sedan) {
      product_name = 'ประกันรถยนต์ชั้น 2+ + พ.ร.บ.รถยนต์'
    } else if (product_count > 1 && has_three && has_sedan) {
      product_name = 'ประกันรถยนต์ชั้น 3 + พ.ร.บ.รถยนต์'
    } else if (product_count === 1 && (has_sedan || has_van || has_pickup)) {
      if (has_sedan) {
        product_name = 'พ.ร.บ.รถยนต์'
      } else if (has_van) {
        product_name = 'พ.ร.บ.รถตู้'
      } else if (has_pickup) {
        product_name = 'พ.ร.บ.รถกระบะ'
      }
    } else if (has_cmi) {
      product_name = 'พ.ร.บ.รถยนต์'
    }
    return (
      <Wrapper>
        <Body>
          <div className={classes.backgroundImageContainer}>
            <img
              alt="background_image"
              className={classes.backgroundImage}
              src={BackgroundImage}
            />
          </div>
          <div className={classes.container}>
            <Grid container>
              <Grid item xs={12}>
                <div className={classes.card}>
                  <div
                    className={classes.cardContent}
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      flexDirection: 'column',
                      alignItems: 'center',
                    }}
                  >
                    <div style={{ position: 'relative' }}>
                      <img
                        src={isSuccess ? BKIimage : SuccessFailed}
                        alt="bki"
                        className={
                          isSuccess ? classes.bkiLogoSuccess : classes.bkiLogo
                        }
                      />
                      {false && (
                        <img
                          src={iconFailed}
                          alt="failed"
                          style={{
                            position: 'absolute',
                            width: '20px',
                            height: '20px',
                            right: '30px',
                            bottom: '30px',
                          }}
                        />
                      )}
                    </div>
                    {/*<span className={classes.cardHeaderTitle}>
                      ออกกรมธรรม์แล้ว
                    </span>*/}
                    <span className={classes.cardHeaderDesc}>
                      {isSuccess
                        ? [
                            'ขอขอบคุณในความไว้วางใจ',
                            <br />,
                            'ใน แอสเซนด์ แอสชัวรันส์ โบรกเกอร์',
                          ]
                        : 'ระบบไม่สามารถ ออกกรมธรรม์ได้'}
                    </span>
                  </div>
                </div>
              </Grid>
            </Grid>

            <Grid container>
              <Grid item xs={12}>
                <div className={classes.card}>
                  {isSuccess && (
                    <div className={classes.cardHeader}>
                      <span
                        className={classes.cardTitle}
                        style={{
                          color: '#0e162c',
                        }}
                      >
                        รายละเอียดกรมธรรม์
                      </span>
                      <img
                        src={BKIimageText}
                        style={{ height: '20px' }}
                        alt="bki"
                      />
                    </div>
                  )}
                  <div className={classes.cardContent}>
                    {isSuccess === false && (
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldValue}>
                          เจ้าหน้าที่จากบมจ.กรุงเทพประกันภัย
                          จะติดต่อคุณเพื่อยืนยันการออกกรมธรรม์
                        </span>
                      </div>
                    )}
                    <div className={classes.fieldContainer}>
                      <span className={classes.fieldTitle}>เลขที่อ้างอิง</span>
                      <span className={classes.fieldValue}>
                        {_.get(transaction, 'resp_transaction_id', '')}
                      </span>
                    </div>
                    {isSuccess && (
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          หมายเลขกรมธรรม์
                        </span>
                        {policyNumber}
                      </div>
                    )}
                    {isSuccess && (
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          ประเภทประกันภัย
                        </span>
                        <span className={classes.fieldValue}>
                          {product_name}
                        </span>
                      </div>
                    )}
                    {isSuccess && (
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>เลขทะเบียนรถ</span>
                        <span className={classes.fieldValue}>{plate}</span>
                      </div>
                    )}
                    {isSuccess && (
                      <div className={classes.fieldContainer}>
                        <span className={classes.fieldTitle}>
                          คุ้มครองตั้งแต่วันที่
                        </span>
                        <span className={classes.fieldValue}>{dateFromTo}</span>
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
            {isSuccess && (
              <div>
                <span
                  className={classes.textFade}
                  style={{ paddingBottom: '0px' }}
                >
                  คุณจะได้รับกรมธรรม์ทางอีเมล {email}
                  จาก บมจ.กรุงเทพประกันภัย ภายใน 20 นาที
                </span>
                <span
                  className={classes.textFade}
                  style={{ paddingTop: '0px', paddingBottom: '0px' }}
                >
                  หากไม่ได้รับอีเมล
                </span>
                <span
                  className={classes.textFade}
                  style={{ paddingTop: '0px' }}
                >
                  กรุณาติดต่อ บมจ.กรุงเทพประกันภัย โทร. 02 285 8888
                </span>
                <span
                  className={classes.textFade}
                  style={{ paddingTop: '0px' }}
                >
                  สอบถามเพิ่มเติมอื่นๆ กรุณาติดต่อ แอสเซนด์ แอสชัวรันส์
                  โบรกเกอร์ โทร. 1240
                </span>
              </div>
            )}
            {isSuccess === false && (
              <div>
                <span
                  className={classes.textFade}
                  style={{ paddingBottom: '0px' }}
                >
                  สอบถามเพิ่มเติม{' '}
                </span>
                <span
                  className={classes.textFade}
                  style={{ paddingTop: '0px' }}
                >
                  บมจ.กรุงเทพประกันภัย โทร. 02 285 8888
                </span>
              </div>
            )}
          </div>
          <Modal styles={{ outline: 0 }} open={isLoading}>
            <div
              style={{
                width: '100%',
                height: '100%',
                backgroundColor: 'white',
              }}
            >
              <Loading />
            </div>
          </Modal>
        </Body>
        <Header>
          <TopBar close={this.goToNextPage}>
            <Typography align="center" className={classes.textTopBar}>
              รายการสั่งซื้อ
            </Typography>
          </TopBar>
        </Header>
      </Wrapper>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    userInput: _.get(state, 'motor.userInput', {}),
    currentProduct: _.get(state, 'motor.userInput.currentProduct', ''),
    selectPrice: _.get(state, 'motor.userInput.selectPrice', 0),
    insuranceClass: _.get(state, 'motor.userInput.insuranceClass', ''),
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    resignAuth: data => {
      dispatch({
        type: 'RESIGN_AUTH',
        data,
      })
    },
    resignMotor: data => {
      dispatch({
        type: 'RESIGN_MOTOR',
        data,
      })
    },
    showError: message => {
      dispatch({
        type: 'ME',
        data: {
          isShowError: true,
          errorMessage: message,
        },
      })
    },
  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(styles)(PaymentSuccessMotor))
